import React from 'react';
import classNames from 'classnames';
import * as styles from './search_form.module.sass';
import { SearchFormProps } from './props.types';

export const SearchForm = (props: SearchFormProps) => {
  return (
    <form method="GET" action="/uk/experts">
      <div className={classNames(styles.search_box, { [styles.search_box_mobile_display]: props.mobile_display })}>
        <input
          placeholder={props.placeholder}
          className={classNames(styles.search_box__input, props.className)}
          onInput={undefined}
          name='name'
        />
        <i></i>
      </div>
    </form>
  );
};
